import RestService from '../services/rest';

async function getBrands() {
  return RestService.getAuthenticated('panel/brands');
}

async function getAllBrands() {
  return RestService.getAuthenticated('panel/brands/list');
}

export default {
  getBrands,
  getAllBrands,
};
